import { useEffect, useState } from "react";
import globalLogger from "@lazarentertainment/js-logger";
import { usePublicChatContext } from "./publicChatProvider";
/**
 * Returns a boolean indicating if there is at least one message in the
 * given range.
 */
export function useHasMessages(start, end) {
    const { fetchMessages, initialized } = usePublicChatContext();
    const [hasMessages, setHasMessages] = useState(null);
    useEffect(() => {
        if (!initialized) {
            return;
        }
        fetchMessages({
            type: "range",
            limit: 1,
            start: end,
            end: start,
            loadActionsStrategy: "none",
        })
            .then((messages) => setHasMessages(!!messages.length))
            .catch(globalLogger.error);
    }, [initialized, start, end]);
    return hasMessages;
}
